<template>
 <section class="content">
   <div>
     <b-alert variant="danger"
            dismissible
            :show="showDismissibleAlert"
            @dismissed="showDismissibleAlert=false">
     {{messageAlert}}
   </b-alert>
   </div>
   <div class="row center-block" v-if="exibirGrafico">
     <div class="col-md-12">
       <div class="box">
         <div class="box-header">
           <h3 class="box-title">Desempenho</h3>
         </div>
         <!-- /.box-header -->
         <div class="box-body">
           <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
             <div class="row">
               <div class="col-sm-6">
                 <div id="example1_length" class="dataTables_length">
                 </div>
               </div>
             </div>
             <div class="row">
               <div class="col-sm-12 table-responsive">
                 <table class="table table-bordered table-striped">
                   <thead>
                     <tr>
                        <th>Data</th>
                        <th>Num Setups</th>
                        <th>Total Produzido</th>
                        <th>Tempo Ocioso</th>
                        <th>Tempo Produzindo</th>
                        <th>Tempo Setup</th>
                        <th>Turno</th>
                        <th>Tempo Médio Setup</th>
                        <th>Prod. Caixa/Top</th>
                        <th>Prod. Caixa/T.D</th>
                        <th>Prod. Caixa/Setup</th>
                        <th>Perc. Operando</th>
                        <th>Perc. Setup</th>
                        <th>Perc. Ocioso</th>
                      </tr>
                   </thead>
                   <tbody>
                     <tr v-for="(data, index) in relatorios.tabeladesempenho" :key="index">
                       <td >{{ajustarData(index)}}</td>
                       <td >{{data.qtdSetup}}</td>
                       <td >{{data.total}}</td>
                       <td >{{data.horasOciosas}}</td>
                       <td >{{data.horasoperando}}</td>
                       <td >{{data.horasFuncaoString}}</td>
                       <td >{{data.horasTrabalho}}</td>
                       <td >{{data.mediaSetup}}</td>
                       <td >{{Math.round(data.prodCaixaTop)}}</td>
                       <td >{{Math.round(data.prodCaixaTD)}}</td>
                       <td >{{Math.round(data.prodCaixaSetup)}}</td>
                       <td >{{Math.round(data.percentualOperando)}}%</td>
                       <td >{{Math.round(data.percentualFuncao)}}%</td>
                       <td >{{100 - Math.round(data.percentualOperando) - Math.round(data.percentualFuncao)}}%</td>
                     </tr>
                   </tbody>
                   <tfoot>
                    <tr>
                      <td><strong>Total</strong></td>
                      <td><strong>{{relatorios.tabelaTotalDesempenho.qtdSetup}}</strong></td>
                      <td><strong>{{relatorios.tabelaTotalDesempenho.total}}</strong></td>
                      <td><strong>{{relatorios.tabelaTotalDesempenho.horasOciosas}}</strong></td>
                      <td><strong>{{relatorios.tabelaTotalDesempenho.horasoperando}}</strong></td>
                      <td><strong>{{relatorios.tabelaTotalDesempenho.horasFuncaoString}}</strong></td>
                      <td><strong>{{relatorios.tabelaTotalDesempenho.horasTrabalho}}</strong></td>
                      <td><strong>{{relatorios.tabelaTotalDesempenho.mediaSetup}}</strong></td>
                      <td><strong>{{Math.round(relatorios.tabelaTotalDesempenho.prodCaixaTop)}}</strong></td>
                      <td><strong>{{Math.round(relatorios.tabelaTotalDesempenho.prodCaixaTD)}}</strong></td>
                      <td><strong>{{Math.round(relatorios.tabelaTotalDesempenho.prodCaixaSetup)}}</strong></td>
                      <td><strong>{{Math.round(relatorios.tabelaTotalDesempenho.percentualOperando)}}%</strong></td>
                      <td><strong>{{Math.round(relatorios.tabelaTotalDesempenho.percentualFuncao)}}%</strong></td>
                      <td><strong>{{100 - Math.round(relatorios.tabelaTotalDesempenho.percentualOperando) - Math.round(relatorios.tabelaTotalDesempenho.percentualFuncao)}}%</strong></td>
                    </tr>
                   </tfoot>
                 </table>
               </div>
             </div>
           </div>
           <!-- /.box-body -->
         </div>
       </div>
     </div>
   </div>
   <div class="row center-block">
     <div class="col-md-12" >
       <div class="box">
         <div class="box-header col-md-12">
           <h3>Requisitos de pesquisa</h3>
           <div class="form-group col-sm-12">
             <label for="dataInicioBusca" class="col-sm-2 control-label">Data Inicial</label>
             <div class="col-sm-4">
               <datepicker :language="ptBR" placeholder="Selecione a data inicial" v-model="dataInicioBusca" id="dataInicioBusca"></datepicker>
             </div>
             <label for="dataFimBusca" class="col-sm-2 control-label">Data Final</label>
             <div class="col-sm-4">
               <datepicker :language="ptBR" placeholder="Selecione a data final" v-model="dataFimBusca" id="dataFimBusca"></datepicker>
             </div>
           </div>
         </div>
         <!-- /.box-header -->
         <div class="box-body">
           <div class="form-group col-sm-4" >
             <label for="maquinas" class="col-sm-2 control-label">Máquina</label>
             <select id="maquinas" class="form-control col-sm-4" v-model="pesquisa.idcontrolador">
               <option value="0">Selecione a Máquina</option>
               <option :value="monitor.id" v-for="monitor in monitores" :key="monitor.id">{{monitor.nomemaquina}}</option>
             </select>
           </div>
           <div class="form-group col-sm-4" >
             <label for="turnos" class="col-sm-2 control-label">Turno</label>
             <select id="turnos" class="form-control col-sm-4" v-model="pesquisa.idTurnoSelecionado">
               <option value="0">Selecione o Turno</option>
               <option :value="turno.id" v-for="turno in turnos" :key="turno.id">{{turno.nometurno}}</option>
             </select>
           </div>
         </div>
         <div class="box-footer">
           <div class="col-sm-2" v>
             <button type="button" v-on:click="efetuarPesquisa()" class="btn btn-primary" v-if="pesquisa.isDadosDisponiveis || pesquisa.isDadosOperando || pesquisa.isDadosFuncao || pesquisa.isDadosOutros">
               Efetuar Pesquisa
             </button>
             <button type="button" class="btn btn-primary"  disabled v-else>
               Efetuar Pesquisa
             </button>
           </div>
         </div>
         <!-- /.box-body -->
       </div>
     </div>
   </div> 
 </section>
</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import Datepicker from 'vuejs-datepicker'
import VAChart from '../widgets/VAChart'
import {ptBR} from 'vuejs-datepicker/dist/locale'

export default {
  name: 'RelatoriosProducaoPedidosTempo',
  components: {
    VueTimepicker,
    Datepicker,
    'va-chart': VAChart
  },
  mounted() {
    if (window.localStorage.getItem('token') === null) {
      this.showDismissibleAlert = true
      this.messageAlert = 'Favor efetuar o login para visualizar os dados'
    }
  },
  computed: {
    turnos () {
      return this.$store.state.Turnos.all
    },
    monitores () {
      return this.$store.state.Controladores.all
    },
    relatorios () {
      return this.$store.state.Relatorios
    },
    isMobile () {
      return (window.innerWidth <= 800 && window.innerHeight <= 600)
    }
  },
  data () {
    return {
      ptBR: ptBR,
      showDismissibleAlert: false,
      messageAlert: '',
      dataInicioBusca: '',
      dataFimBusca: '',
      pesquisa: {
        dataInicioBusca: '',
        dataFimBusca: '',
        idTurnoSelecionado: 0,
        idcontrolador: 0,
        isDadosOperando: true,
        isDadosFuncao: false,
        isDadosDisponiveis: false,
        isDadosOutros: false
      },
      exibirGrafico: false,
      errors: []
    }
  },
  methods: {
    ajustarData: function(data) {
      if (data === 'Total') {
        return data
      }
      let dataAtual = data.split('-')
      return (dataAtual[2] + '/' + dataAtual[1])
    },
    efetuarPesquisa: function() {
      this.exibirGrafico = false
      if (!window.localStorage.getItem('token')) {
        this.showDismissibleAlert = true
        this.messageAlert = 'Favor efetuar o login para buscar o relatório'
      } else if ((this.dataInicioBusca === '') || (this.dataFimBusca === '')) {
        this.showDismissibleAlert = true
        this.messageAlert = 'Não pode ter data vazia'
      } else if (this.dataInicioBusca > this.dataFimBusca) {
        this.showDismissibleAlert = true
        this.messageAlert = 'Data final não pode ser anterior à data inicial'
      } else if (this.pesquisa.idcontrolador === 0) {
        this.showDismissibleAlert = true
        this.messageAlert = 'Favor selecionar uma Máquina para pesquisa'
      } else if (this.pesquisa.idTurnoSelecionado === 0) {
        this.showDismissibleAlert = true
        this.messageAlert = 'Favor selecionar um turno para pesquisa'
      } else {
        this.showDismissibleAlert = false
        this.pesquisa.dataInicioBusca = this.dataInicioBusca.toISOString().substring(0, 10)
        this.pesquisa.dataFimBusca = this.dataFimBusca.toISOString().substring(0, 10)
        this.$store.dispatch('createRelatorioProducaoPedidosTempo', this.pesquisa)
        .then(response => {
          this.exibirGrafico = true
        })
        .catch(e => {
          this.errors.push(e)
        })
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// RelatoriosProducaoPedidosTempo.vue?82f1fdfe